/**
 * Style constants for OnboardingForm
 */

import { CSSProperties } from "react";

export const STYLES = {
  container: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
  } as CSSProperties,

  scrollArea: {
    flex: 1,
    maxHeight: "calc(100vh - 100px)",
    maxWidth: "150vh",
  } as CSSProperties,

  modalActions: {
    marginTop: "20px",
    display: "flex",
    gap: "10px",
  } as CSSProperties,
} as const;

/**
 * Navigation paths
 */
export const ROUTES = {
  ONBOARDING_LIST: "/onboarding",
} as const;
